<template>
  <div class="fm-list">
    <HomeList :getListApi="getbusinesses" :params="homeListParams">
      <template>
        <FMItem
          v-for="(item, index) in fmList"
          :key="index"
          :fmInfo="item"
          @goDes="goDes"
        ></FMItem>
      </template>
    </HomeList>
  </div>
</template>
<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import FMItem from 'component/platform/homepage/normalUser/fmItem.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  props: {},
  mixins: [homepageMixin],
  components: {
    HomeList,
    FMItem
  },
  data() {
    return {
      homeListParams: {}
    }
  },
  computed: {
    fmList() {
      return this.$store.getters['homepage/getTabListData']('fm') || []
    }
  },
  created() {},
  mounted() {
    // 获取token, 再发起请求
    this.mixinGetToken().then(token => {
      this.token = token
      this.homeListParams = {
        user_id: this.$route.params.userId,
        token: token,
        business_type: 'fm'
      }
    })
  },
  methods: {
    goDes() {
      this.$trackEvent('newprofilepages_fm_click', {})
    },
    getbusinesses(params) {
      return this.$store.dispatch('homepage/fetchBusinesses', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.fm-list {
  margin: 30px 0;
}
</style>
